import { pathOr } from 'ramda';

export const isFeatureEnabled = feature => pathOr([], ['_infl', 'hub', 'features'], window || {}).includes(feature);

  export const profileId =
    window &&
    window._infl &&
    window._infl.currentContact &&
    window._infl.currentContact.id || '';

export const isMultilingualHub = isFeatureEnabled('multilingual_content');

export const isFroalaAIGeneratorEnabled = isFeatureEnabled('froala_ai_generator');



// WEBPACK FOOTER //
// ./src/shared/utils.js